import React, { useState, useRef, useEffect } from 'react'
import { useCombinedRefs } from '../../utils/useForm'
import PropTypes from 'prop-types'
import Popover from './Popover'

const propTypes = {
  /**
   * The label of the `FormGroup`
   */
  label: PropTypes.string,
  /**
   * An element or text to overlay next to the `FormGroup`
   */
  popoverText: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
}

const FormGroup = React.forwardRef((props, ref) => {
  const [container, setContainer] = useState()
  const innerRef = useRef()
  const combinedRef = useCombinedRefs(ref, innerRef)

  useEffect(() => {
    setContainer(combinedRef.current)
  })

  const popover = (
    <>
      {props.popoverText ? (
        <Popover
          container={container}
          className="Popover"
          overlay={{ content: (<>{props.popoverText ? props.popoverText : ''}</>) }}
        />
      ) : null}
    </>
  )

  const helpModal = (
    <>
      { props.helpTextModal ? (
        <span className="popoverTrigger" onClick={props.helpTextModal.openModal}></span>
      ) : null}
    </>
  )

  return (
    <div ref={combinedRef} className={"formGroup" + (props.className ? " " + props.className : "") + (props.warning ? " -warning" : "")} >
      { props.label ?
        <label className="formGroup__title">{props.label}{props.warning ? "*" : ""}{props.popoverText ? popover : ''}{props.helpTextModal ? helpModal : ''}
        </label> : null
      }
      { props.labelText ?
        <span style={{display:"inline"}}>{props.labelText}{props.popoverText ? popover : ''}</span> : null
      }

      {props.children}
{/*
      { props.labelTextOnRight ?
        <span style={{display:"inline"}}>{props.popoverText ? popover : ''}</span> : null
      }
*/}
    </div>
  )
})

FormGroup.propTypes = propTypes

export default FormGroup
